/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Sorting = {
  properties: {
    sort: {
      type: 'string',
      isRequired: true,
      isNullable: true,
    },
    order: {
      type: 'string',
      isRequired: true,
      isNullable: true,
    },
  },
} as const;
